// extracted by mini-css-extract-plugin
export default {"button_scroll_top":"ScrollToTopAnswer_button_scroll_top__k3-VT","show":"ScrollToTopAnswer_show__toxKM","bounce":"ScrollToTopAnswer_bounce__8pcuL"};